import { HistogramThresholdBar } from './HistogramThresholdBar.js';
import { ChartGrid } from '../../../core/components/chart-grid/ChartGridRoot.js';
import { AREAS } from '../../constants/histogram-grid-area-rules.js';

export const HistogramThresholdArea = () => (
  <>
    <ChartGrid.GridArea gridArea={AREAS.leftThreshold}>
      {({ availableHeight }) => (
        <HistogramThresholdBar length={availableHeight} position="left" />
      )}
    </ChartGrid.GridArea>

    <ChartGrid.GridArea gridArea={AREAS.rightThreshold}>
      {({ availableHeight }) => (
        <HistogramThresholdBar length={availableHeight} position="right" />
      )}
    </ChartGrid.GridArea>
  </>
);

HistogramThresholdArea['displayName'] = 'HistogramThresholdArea';
